export default "__VITE_ASSET__C0KiHP63__"